import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { Box } from "@shopify/polaris";
import { useEffect } from "react";
import Stack from "../../Stack";
import styled from "styled-components";
import paletteColors from "../../../theme/paletteColors";

const Text = styled.p`
  font-size: 13px;
  font-weight: 450;
  font-family: "Inter";
`;
const LabelText = styled(Text)`
  color: ${({ $color }) => $color};
  font-weight: 550;
`;

export const SwitchComponent = ({ field, name, label, disabled, onChange }) => {
  useEffect(() => {
    const hiddenInput = document.getElementById(`${name}-hidden`);
    if (hiddenInput) {
      hiddenInput.checked = field.value;
    }
  }, [field.value, name]);

  return (
    <Stack alignItems="center" spacing={2}>
      <LabelText $color={paletteColors.light.dark}>{`${label}${label ? ":" : ""}`}</LabelText>
      <Box
        as="button"
        type="button"
        name={name}
        aria-label={name}
        onClick={() => {
          const newValue = !field.value;
          field.onChange(newValue);
          if (onChange) {
            onChange(newValue);
          }
          const hiddenInput = document.getElementById(`${name}-hidden`);
          if (hiddenInput) {
            hiddenInput.checked = newValue;
            hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }}
        disabled={disabled}
        style={{
          width: "40px",
          height: "24px",
          borderRadius: "4px",
          backgroundColor: field.value ? "#000" : "#E5E5E5",
          position: "relative",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          padding: "2px",
          transition: "background 0.2s",
        }}
      >
        <Box
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "4px",
            backgroundColor: "#fff",
            position: "absolute",
            left: field.value ? "calc(100% - 20px)" : "4px",
            transition: "left 0.2s",
          }}
        />
      </Box>
      <input id={`${name}-hidden`} type="checkbox" defaultChecked={field.value} style={{ display: "none" }} />
    </Stack>
  );
};

SwitchComponent.propTypes = {
  field: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

RHFSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default function RHFSwitch({ name, label, disabled = false, onChange }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SwitchComponent field={field} name={name} label={label} disabled={disabled} onChange={onChange} />
      )}
    />
  );
}
